import React from 'react';
import ReactDOMClient from 'react-dom/client';
import './index.css'
import SwitchRoutes from './routes/SwitchRoutes';
import { BrowserRouter } from 'react-router-dom';
import MenuProvider from './components/provider/MenuProvider';
import { HelmetProvider } from 'react-helmet-async';

const container = document.getElementById("root") || document.createElement("div");
const root = ReactDOMClient.createRoot(container);
const helmetContext = {};
root.render(
  <React.StrictMode>
    <HelmetProvider context={helmetContext}>
      <BrowserRouter basename='/'>
        <MenuProvider>
          <SwitchRoutes />
          <div style={{
            color: " #666666ff",
            textAlign: "center",
            marginTop: "2%"
          }}>Not liable for misuse or inaccuracies.</div>
        </MenuProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode >
);